<app-header></app-header>
<section class="content-box">
    <div class="tab-content" id="myTabContent">
        <!--  market Position -->
        <div class="tab-pane fade show active" id="market">
            <div class="deta-tebal-box">
              

                <div class="setin-boxs-history ">
                    <table class="teble-buy-sell" *ngIf="badlaCategory == 'minutewise'">
                        <thead>
                            <th>#</th>
                            <th>Buy</th>
                            <th>Sell</th>
                            <th>LTP</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>H</td>
                                <td [ngClass]="minLTPBadla > 0 ? 'credit-color' : 'debit-color'">{{minLTPBadla}}</td>
                                <td [ngClass]="minBuyBadla > 0 ? 'credit-color' : 'debit-color'">{{minBuyBadla}}</td>
                                <td [ngClass]="minSellBadla > 0 ? 'credit-color' : 'debit-color'">{{minSellBadla}}</td>
                            </tr>
                            <tr>
                                <td>L</td>
                                <td [ngClass]="maxLTPBadla > 0 ? 'credit-color' : 'debit-color'">{{maxLTPBadla}}</td>
                                <td [ngClass]="maxBuyBadla > 0 ? 'credit-color' : 'debit-color'">{{maxBuyBadla}}</td>
                                <td [ngClass]="maxSellBadla > 0 ? 'credit-color' : 'debit-color'">{{maxSellBadla}}</td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <div class="fileter-box">
                        <select class="form-control w-25 col-w defot-secot-box" name="badlaCat" [(ngModel)]="badlaCategory" (change)="badlaCategoryChange($event.target.value)">
                            <option value="daywise">Day wise</option>
                            <option value="minutewise">Minute wise</option>
                        </select> 
                        <select class="form-control w-25 col-w defot-secot-box mr-3" name="badlaType" [(ngModel)]="selectedBadlaType" (change)="badlaTypeChnage($event.target.value)">
                            <option *ngFor="let category of instrumentCategory; let i = index;" value="{{category.name}}">{{category.name}}</option>
                        </select>
                        <select class="form-control w-25 col-w defot-secot-box" name="badlaType" [(ngModel)]="selectedScript">
                            <option [ngValue]="null">Select Badla</option>
                            <option *ngFor="let badlaIns of allScript; let i = index;" value="{{badlaIns._id}}">{{badlaIns.settingName}}</option>
                        </select>   
                        <input class="form-control date-input-serch " *ngIf="badlaCategory == 'minutewise'" type="date" placeholder="{{sDate}}" [(ngModel)]="selectedDate"  />

                        <input class="form-control date-input-serch " *ngIf="badlaCategory == 'daywise'" type="date" placeholder="{{sDate}}" [(ngModel)]="selectedDate"  />
                        <input class="form-control date-input-serch " *ngIf="badlaCategory == 'daywise'" type="date" placeholder="{{eDate}}" [(ngModel)]="selectedDateE"  />
                        
                        <button type="button" class="btn but-boxa btn-primary but-box-serch" (click) = "findHistory()">
                            Search
                        </button>
                    </div>
     
                 
                </div>
                <div class="respo-scroll">
                    <table class="default-table-style"  *ngIf="badlaCategory == 'minutewise'">
                        <thead>
                            <tr >
                                <th class="text-left">Date/Time</th>
                                <th class="text-center">Badla[BUY]</th>
                                <th class="text-center">Badla[SELL]</th>
                                <th class="text-center">Badla[LTP]</th>
                                <th class="text-center">
                                    <p>MCX BID</p>
                                    <p class="mcx-doller-rate">Comex (INR)</p>
                                </th>
                                <th class="text-center">
                                    <p>MCX ASK</p>
                                    <p class="mcx-doller-rate">Comex (INR)</p>
                                </th>
                                <th class="text-center">COMEX BID</th>
                                <th class="text-center">COMEX ASK</th>
                                <th class="text-center">DGCX BID</th>
                                <th class="text-center">DGCX ASK</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="historyData.length > 0">
                                <tr *ngFor="let binstu of historyData; let i = index;">
                                    <td class="text-left">
                                        {{binstu['historyDate'] | date : 'dd/MM/yyyy h:mm a'}}
                                     </td>
                                    <td class="text-center" [ngClass]="binstu['finalBadla'] > 0 ? 'credit-color' : 'debit-color'">{{binstu['finalBadla']}}</td>
                                    <td class="text-center" [ngClass]="binstu['finalBadlaBuy'] > 0 ? 'credit-color' : 'debit-color'">{{binstu['finalBadlaBuy']}}</td>
                                    <td class="text-center" [ngClass]="binstu['finalBadlaSell'] > 0 ? 'credit-color' : 'debit-color'">{{binstu['finalBadlaSell']}}</td>
                                    <td class="text-center">
                                        <p >{{binstu['mcxBuyPrice']}}</p>
                                        <p class="mcx-doller-rate">{{binstu['dollerBuy']}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p >{{binstu['mcxSellPrice']}}</p>
                                        <p class="mcx-doller-rate">{{binstu['dollerSell']}}</p>
                                    </td>
                                    <td class="text-center" ><span>{{binstu['comexBuyPrice']}}</span> </td>
                                    <td class="text-center" ><span>{{binstu['comexSellPrice']}}</span></td>
                                    <td class="text-center" >
                                        <p >{{binstu['dgcxBuyPrice']}}</p>
                                        <p class="mcx-doller-rate">{{binstu['dollerPBuy']}}</p>
                                    </td>
                                    <td class="text-center">
                                        <p >{{binstu['dgcxSellPrice']}}</p>
                                        <p class="mcx-doller-rate">{{binstu['dollerPSell']}}</p>
                                    </td>
                                 </tr>         
                            </ng-container>
                             <ng-container *ngIf="historyData.length == 0">
                                <tr>
                                    <td class="text-center m-0 p-0 " colspan="12">No record found</td>
                                </tr>    
                            </ng-container>  
                        </tbody>
                    </table>

                    <table class="default-table-style"  *ngIf="badlaCategory == 'daywise'">
                        <thead>
                            <tr >
                                <!-- <th>#</th> -->
                                <th class="text-left">Date/Time</th>
                                <th class="text-center">Badla[BUY]</th>
                                <th class="text-center">Badla[SELL]</th>
                                <th class="text-center">Badla[LTP]</th>                                
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="historyRange.length > 0">
                                <tr *ngFor="let binstu of historyRange; let i = index;">
                                    <!-- <td class="text-left">
                                        <div class="h-l-box">
                                            <p>H</p>
                                            <p>L</p>
                                        </div>
                                    </td> -->
                                    <td class="text-left">
                                        <div class="h-l-box">
                                            <p>{{binstu['historyDate'] | date : 'dd/MM/yyyy'}}</p>
                                            
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="h-l-box">
                                            <p>H : <span [ngClass]="binstu['maxBuyBadla'] > 0 ? 'credit-color' : 'debit-color'">{{binstu['maxBuyBadla']}}</span></p>
                                            <p>L : <span [ngClass]="binstu['minBuyBadla'] > 0 ? 'credit-color' : 'debit-color'">{{binstu['minBuyBadla']}}</span></p>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="h-l-box">
                                            <p>H : <span [ngClass]="binstu['maxSellBadla'] > 0 ? 'credit-color' : 'debit-color'"> {{binstu['maxSellBadla']}} </span></p>
                                            <p>L : <span [ngClass]="binstu['minSellBadla'] > 0 ? 'credit-color' : 'debit-color'"> {{binstu['minSellBadla']}} </span></p>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="h-l-box">
                                            <p>H : <span [ngClass]="binstu['maxLTPBadla'] > 0 ? 'credit-color' : 'debit-color'">{{binstu['maxLTPBadla']}}</span></p>
                                            <p>L : <span [ngClass]="binstu['minLTPBadla'] > 0 ? 'credit-color' : 'debit-color'">{{binstu['minLTPBadla']}}</span></p>
                                        </div>
                                    </td>
                                 </tr> 
                            </ng-container>
                             <ng-container *ngIf="historyRange.length == 0">
                                <tr>
                                    <td class="text-center m-0 p-0 " colspan="12">No record found</td>
                                </tr>    
                            </ng-container>  
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
